import React from 'react'
import styled from 'styled-components'
import CloseRoundedIcon from '@mui/icons-material/CloseRounded'

const TONES = {
  keep: { bg: '#dcfce7', fg: '#15803d', bd: '#15803d33' },
  hide: { bg: '#fef3c7', fg: '#b45309', bd: '#b4530933' },
  delete: { bg: '#fdecea', fg: '#b00020', bd: '#b0002033' },
  mark: { bg: '#ffedd5', fg: '#c2410c', bd: '#c2410c33' },
  ok: { bg: 'rgba(42,166,179,0.10)', fg: '#2aa6b3', bd: 'rgba(42,166,179,0.32)' },
  mute: { bg: '#f1f3f7', fg: '#4a4f5e', bd: '#e6e8ec' }
}

export const BulkBtn = styled.button`
  font: inherit;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  white-space: nowrap;
  padding: 7px 13px;
  border-radius: 8px;
  font-size: 12.5px;
  font-weight: 800;
  letter-spacing: 0.02em;
  cursor: pointer;
  background: ${({ $tone }) => (TONES[$tone] || TONES.mute).bg};
  color: ${({ $tone }) => (TONES[$tone] || TONES.mute).fg};
  border: 1px solid ${({ $tone }) => (TONES[$tone] || TONES.mute).bd};
  transition: filter 140ms ease;

  &:hover:not(:disabled) { filter: brightness(0.97); }
  &:disabled { opacity: 0.5; cursor: wait; }
`

const BulkActionBar = ({ count, onClear, children, noun = 'item', busy = false }) => {
  if (!count) return null

  return (
    <Bar role='region' aria-label='Bulk actions'>
      <Count>{count} {noun}{count === 1 ? '' : 's'} selected</Count>
      <Clear type='button' onClick={onClear} disabled={busy} title='Clear selection'>
        <CloseRoundedIcon style={{ fontSize: 15 }} /> Clear
      </Clear>
      <Spacer />
      <Actions>{children}</Actions>
    </Bar>
  )
}

export default BulkActionBar

const Bar = styled.div`
  position: sticky;
  top: 0;
  z-index: 5;
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  padding: 10px 14px;
  margin-bottom: 12px;
  border-radius: 10px;
  background: #eef2ff;
  border: 1px solid #c7d2fe;
`

const Count = styled.span`
  font-size: 13px;
  font-weight: 800;
  color: #1b2233;
`

const Clear = styled.button`
  font: inherit;
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 4px 9px;
  border-radius: 7px;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  color: #4a4f5e;
  background: #fff;
  border: 1px solid #d7dbe3;

  &:hover:not(:disabled) { background: #f8fafc; }
  &:disabled { opacity: 0.5; cursor: wait; }
`

const Spacer = styled.span`flex: 1 1 auto;`

const Actions = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`
